import { render, staticRenderFns } from "./LiveRecordDialog.vue?vue&type=template&id=6c534c71&scoped=true"
import script from "./LiveRecordDialog.vue?vue&type=script&lang=js"
export * from "./LiveRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveRecordDialog.vue?vue&type=style&index=0&id=6c534c71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c534c71",
  null
  
)

export default component.exports